// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
'use client'

import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import { getIpLocation } from 'services/ipLocation'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Captcha from 'components/captcha'
import { useRouter } from 'next/navigation'
import { usePageSlug } from 'hooks/useRouteInfo'
import { FC, useEffect, useState } from 'react'
import { Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'
import { CDN_URL } from 'config/site'
import Button from 'components/Button'

type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput: string
  skypeID: string
  projectRequirements: string
}
interface CaptchaDetails {
  firstValue?: number
  secondValue?: number
  ans?: number
  isCaptchaMatched?: boolean
}

const ContactUsSection: FC<{ data: any }> = ({ data }) => {
  const [captchaDetails, setCaptchaDetails] = useState<CaptchaDetails>({})
  const schema = yup.object().shape({
    yourName: yup.string().max(80).trim().required('Your Name is required'),
    yourEmail: yup
      .string()
      .email('Invalid email format')
      .max(255)
      .required('Your Email is required'),
    projectRequirements: yup
      .string()
      .trim()
      .required('Your Project Requirements is required'),
    solution: yup
      .string()
      .required('Captcha is required')
      .test('solution', 'Incorrect solution to math sum', (value: string) => {
        const solution = parseInt(value, 10)
        return solution === captchaDetails.ans
      }),
    phoneInput: yup
      .string()
      .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
        value ? isValidPhoneNumber(value) : true
      ),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')
  const [Loading, setLoading] = useState(false)

  const router = useRouter()
  const pageSlug = usePageSlug()
  const PageUrl = pageSlug

  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const onSubmit: SubmitHandler<FormValues> = async (dataFetch) => {
    setLoading(true)
    setSuccessMesg('')
    setErrorMesg('')
    const newComment = {
      name: dataFetch.yourName,
      email: dataFetch.yourEmail,
      skypeId: '',
      contactNumber: dataFetch.phoneInput,
      pro_requirements: dataFetch.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
    }

    try {
      const result = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/api/user/contactUs/sendInquiry`,
        newComment,
        {
          headers: {
            web_id: 'webcluesinfotech',
          },
        }
      )

      if (result.data.code === 200) {
        setLoading(false)
        setSuccessMesg('Thank you for your message. It has been sent.')
        setTimeout(() => {
          router.push('/thank-you-1')
        }, 100)
      } else {
        setLoading(false)
        const objres = {
          result: 'message',
        }
        setErrorMesg(objres.result)
      }
    } catch (error) {
      setLoading(false)
      setErrorMesg('Please try again after sometime')
    }
  }

  const fetchIpLocation = async () => {
    const result = await getIpLocation()
    if (result.success && result.data) {
      setPhoneCountryCode(result.data.country_code)
      setFromCountryName(result.data.country_name)
    }
  }

  useEffect(() => {
    fetchIpLocation()
  }, [])

  return (
    <section
      className="contactus_section"
      style={{
        background: `url(${CDN_URL}${'/assets/images/contact-bg.jpg'})`,
      }}
    >
      <Container>
        <Row className="justify-content-end">
          <Col lg={8} xl={7} xxl={7} className="bg-white form_block">
            {data?.title ? (
              <TitleH2 className="mb-2 text_black" text={data?.title} />
            ) : (
              <TitleH2 className="mb-2 text_black" text="Hi! Ping Us" />
            )}
            {data?.subTitle ? (
              <SubText className="mb-2" text={data?.subTitle} />
            ) : (
              <SubText
                className="mb-2"
                text="Contacting us is the first step towards success."
              />
            )}

            <div className="mt-4">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex" />
                <Row>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Name *"
                        {...register('yourName')}
                      />
                      <p className="alert-error">
                        {errors.yourName && (
                          <span>{errors.yourName.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={6} className="mb-2">
                    <Form.Group className="mb-3">
                      <Controller
                        name="phoneInput"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            onChange={(e: any) => onChange(e)}
                            defaultCountry={phoneCountryCode}
                            id="phoneInput"
                            className="form-control d-flex"
                            placeholder="Contact Number"
                          />
                        )}
                      />
                      <p className="alert-error">
                        {errors.phoneInput && (
                          <span>{errors.phoneInput.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mb-2">
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Your Email *"
                        {...register('yourEmail')}
                      />
                      <p className="alert-error">
                        {errors.yourEmail && (
                          <span>{errors.yourEmail.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mb-2 pt-3">
                    <Form.Control
                      as="textarea"
                      className="py-0"
                      placeholder="Project Requirements *"
                      {...register('projectRequirements')}
                      rows={4}
                    />
                    <p className="alert-error">
                      {errors.projectRequirements && (
                        <span>{errors.projectRequirements.message}</span>
                      )}
                    </p>
                  </Col>
                  <Col xl={12} className="my-3">
                    <Form.Group className="pb-1 white_bg_captcha">
                      <Captcha onChange={(val) => setCaptchaDetails(val)}>
                        <Form.Control
                          type="text"
                          placeholder="Captcha code"
                          className="bg-transparent"
                          {...register('solution')}
                        />
                      </Captcha>
                      <p className="alert-error mb-0">
                        {errors.solution && (
                          <span>{errors.solution.message}</span>
                        )}
                      </p>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mt-2">
                    <Form.Group className="pb-4">
                      <div className="d-flex">
                        <span className="me-2">
                          <img
                            src={`${CDN_URL}/assets/images/secure-icon.svg`}
                            alt="secure-icon"
                          />
                        </span>
                        <span className="form-check-label">
                          We respect your privacy and do not tolerate spam and
                          will never sell rent lease or give away your
                          information (name, address, email, etc) to any third
                          party. Nor will we send you unsolicited email
                        </span>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xl={12} className="mt-4">
                    <Button className="btn-black" type="submit">
                      <span>Send Request</span>
                    </Button>
                    {Loading && (
                      <Spinner
                        className="ms-3"
                        animation="border"
                        variant="secondary"
                        role="status"
                        size="sm"
                      />
                    )}
                  </Col>
                  {SuccessMesg && (
                    <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-successfully">
                      {SuccessMesg}
                    </p>
                  )}
                  {ErrorMesg && (
                    <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-error">
                      {ErrorMesg}
                    </p>
                  )}
                </Row>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ContactUsSection
